import { createFeatureSelector, createSelector } from '@ngrx/store';
import { newsFeatureKey, State } from './news.reducer';
import { DateUtils } from '~/shared/utils/date.utils';

export const selectNewsFeature = createFeatureSelector<State>(newsFeatureKey);

export const selectNewsItems = createSelector(selectNewsFeature, (state) =>
  [...state.news.items].sort((a, b) => DateUtils.new(b.date).diff(a.date))
);

export const selectNewsIsLoading = createSelector(selectNewsFeature, (state) => state.newsIsLoading);

export const selectReadNewsIds = createSelector(selectNewsFeature, (state) => state.readNewsIds);

export const selectCgeNewsItems = createSelector(selectNewsFeature, (state) => state.cgeNews.items);

export const selectCgeNewsIsLoading = createSelector(selectNewsFeature, (state) => state.cgeNewsIsLoading);

export const selectHasMoreCgeNewsPages = createSelector(selectNewsFeature, (state) => state.hasMoreCgeNewsPages);

export const selectCurrentCgeNewsPage = createSelector(selectNewsFeature, (state) => state.currentCgeNewsPage);

export const selectCgeNewsLoadMoreData = createSelector(
  selectHasMoreCgeNewsPages,
  selectCurrentCgeNewsPage,
  selectCgeNewsItems,
  selectCgeNewsIsLoading,
  (hasMorePages, currentPage, items, isLoading) => ({
    hasMorePages,
    currentPage,
    items,
    isLoading
  })
);
